<!--
 * @Author: chenx
 * @CreatedDate: Do not edit
 * @LastEditTime: 2021-03-23 12:04:02
 * @Description:会议
-->

<template>
  <el-dialog
    :visible="openDia"
    :close-on-click-modal="false"
    @close="closeMeeting"
    width="300px"

  >
    <chat-meeting
      v-if="imAccount && imToken"
      :imAccount="imAccount"
      :imToken="imToken"
      @open="openMeeting = true"
      @close="openMeeting = false"
    ></chat-meeting>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex"
export default {
  props: {
    openDia: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState({
      imAccount: state => state.imAccount,
      imToken: state => state.imToken
    })
  },

  data() {
    return {
      openMeeting: false
    }
  },
  methods: {
    // 关闭会议
    closeMeeting() {
      this.$emit("closeMeeting")
    }
  }
}
</script>
